import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  NgZone
} from '@angular/core';
import { MainPageService } from './../../../main-page.service';
import { Router } from '@angular/router';
import { ChannelModel } from '../../../../models/parts/channel.model';
import { mockedStepFile } from './mock-step-file-base64';
import { CrossSectionModel } from '../../../../models/parts/cross-section.model';
import { SystemModel } from '../../../../models/dictionaries/system.model';
import { CorosiveProtectionModel } from '../../../../models/dictionaries/corosive-protection.model';
import { MaterialModel } from '../../../../models/dictionaries/material.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';


@Component({
  selector: 'app-channels-managment',
  template: `<div *ngIf="channelData !== undefined">
    <div class="row" style="padding-left: 12px;">
        <b>Channel:</b> &nbsp;{{channelData.name}}</div>
    <div class="row" style="margin: 10px;">
        <!-- <button class="gray-button" (click)="openGraphicalTool()" [disabled]="!canOpenGraphicalTool">Open graphical tool</button> -->
        <button class="gray-button" data-toggle="modal" data-target="#editModal">Edit</button>
        <!-- <button class="gray-button" >Drawing/Pictures</button> -->
        <!-- <button class="gray-button" data-toggle="modal" data-target="#uploadModal">Upload file</button> -->
        <button class="gray-button" data-toggle="modal" data-target="#deleteModal">Delete</button>
    </div>
    <div class="row">
        <div class="col-6" style="line-height: 30px;">
            <div class="d-inline">Article no:
            </div>
            <div class="d-inline">{{channelData.articleNumber}}
                <br>
            </div>
            <div class="d-inline">Name:
            </div>
            <div class="d-inline">{{channelData.name}}
                <br>
            </div>
            <div class="d-inline">Description:
            </div>
            <div class="d-inline">{{channelData.description}}
                <br>
            </div>
            <div class="d-inline">System:
            </div>
            <div class="d-inline">{{channelData.system}}
                <br>
            </div>
            <div class="d-inline">Corrosion protection:
            </div>
            <div class="d-inline">{{channelData.corrosionProtection}}
                <br>
            </div>
            <div class="d-inline">Cross section:
            </div>
            <div class="d-inline">{{channelData.crossSection}}
                <br>
            </div>
            <div class="d-inline">Material:
            </div>
            <div class="d-inline">{{channelData.material}}
                <br>
            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div id="stpFileDiv" [hidden]="!isStpVisible">
                    <div class="row">
                        <img height=150 width=150 src="https://www.freeviewer.org/img/stp/overview-stp.png" id="stpPicture">
                    </div>
                    <div class="row">
                        <label style="font-size:12px">STEP FILE</label>
                        <button style="font-size:12px;height:23px;margin-left: 3px;" (click)="deleteStepFile()">x</button>
                        <button style="font-size:12px;height:23px;margin-left: 3px;" (click)="openGraphicalTool()" [disabled]="!canOpenGraphicalTool">
                            Configure
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Upload Modal -->
<div class="modal" id="uploadModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div>
                    Select file:
                    <br/>
                    <input #fileUploadInput type="file" accept=".jpg,.jpeg,.png,.step,.stp">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger save-button" data-dismiss="modal" (click)="upload()">Upload</button>
            </div>

        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Article no:</span>
                                    <input type="number" [(ngModel)]="editedChannel.articleNumber" formControlName="articleNumber">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedChannel.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Description:</span>
                                    <input type="text" [(ngModel)]="editedChannel.description" formControlName="description">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">System:</span>
                                    <select name="systemSelect" class="select-style" [(ngModel)]="editedChannel.system" class="selectHeight" formControlName="system" (ngModelChange)="filterCrossSections()">
                                        <option *ngFor="let system of systemsArray | sortByName" [ngValue]="system.name">{{system.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Corrosion protection:</span>
                                    <select name="corrProtSelect" class="select-style" [(ngModel)]="editedChannel.corrosionProtection" formControlName="corrosionProtection">
                                        <option *ngFor="let corrosionProtection of corrosionProtectionsArray | sortByName" [ngValue]="corrosionProtection.name" class="selectHeight">{{corrosionProtection.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Cross section:</span>
                                    <select name="crossSectionSelect" class="select-style" [(ngModel)]="editedChannel.crossSection" formControlName="crossSection">
                                        <option *ngFor="let crossSection of availableCrossSectionsArray | sortByName" [ngValue]="crossSection.name">{{crossSection.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Material:</span>
                                    <select name="material" class="select-style" [(ngModel)]="editedChannel.material" formControlName="material">
                                        <option *ngFor="let material of materialsArray | sortByName" [ngValue]="material.name">{{material.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="save()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this channel?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" (click)="deleteChannel()">Delete</button>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.regularObjectBorder{border-width:1px;border-style:solid}.justTopBorder{border-bottom:0;border-left:0;border-right:0}.justRightBorder{border-bottom:0;border-left:0;border-top:0}.justBottomBorder{border-right:0;border-left:0;border-top:0}#tabContent{font-size:11px}.modal-label{width:168px}.display-flex{display:flex;align-items:center;margin-bottom:10px}hr{margin-top:0}#variantsGrid{margin-left:17px}.select-style{width:100px}`]
})
export class ChannelsManagmentComponent implements OnInit {
  @ViewChild('fileUploadInput') fileInput;
  @Output() onShowViewer: EventEmitter<boolean> = new EventEmitter();
  @Output() selectedConnectorId: EventEmitter<number> = new EventEmitter();

  public channelData: any;
  public editedChannel = new ChannelModel();
  public showPicture = false;
  public canOpenGraphicalTool = false;
  private stpConvertTaskId: string;
  public mockedStepFileBase64 = mockedStepFile;
  public isStpVisible = false;
  public isPngVisible = false;
  public pictureData: string;
  public allCrossSectionsArray: CrossSectionModel[] = [];
  public availableCrossSectionsArray: CrossSectionModel[] = [];
  public systemsArray: SystemModel[] = [];
  public corrosionProtectionsArray: CorosiveProtectionModel[] = [];
  public materialsArray: MaterialModel[] = [];
  public formGroup: FormGroup;


  constructor(private mainPageService: MainPageService, private zone: NgZone) {}

  public ngOnInit(): void {
    this.allCrossSectionsArray = [];
    this.loadData();
    this.createForm();
   }

   loadData(): void {
    this.mainPageService.loadAllCrossSections().subscribe((response) => {
      this.allCrossSectionsArray = response;
    });
    this.mainPageService.loadAllSystems().subscribe((response) => {
      this.systemsArray = response;
    });
    this.mainPageService.loadAllCorosionProtections().subscribe((response) => {
      this.corrosionProtectionsArray = response;
    });
    this.mainPageService.loadAllMaterials().subscribe((response) =>{
      this.materialsArray = response;
    });
   }

  showChannel(sender) {
    this.channelData = sender;
    this.editedChannel = {
      ...this.channelData
    };
    //this.setRandomFileOrPicture();
    this.setFilesData(sender);
    this.canOpenGraphicalTool = sender.isProtoConverted === true;
    this.selectedConnectorId.emit(sender._id);
  }

  upload(): void {
    this.readThis(this.fileInput.nativeElement.files[0]);
  }

  readThis(inputFile: any): void {
    const file: File = inputFile;
    const myReader: FileReader = new FileReader();
    const scope = this;
    myReader.onloadend = function() {
      if (file.name.includes('.stp') || file.name.includes('.step')) {
        scope.isStpVisible = true;
        scope.sendSTPFile(myReader.result, scope.channelData._id);
      }
    };
    myReader.readAsDataURL(file);
  }

  checkIfStpIsConverted(): void {
    const self = this;
    setTimeout(() => {
      self.mainPageService.checkTaskStatus(self.stpConvertTaskId)
      .subscribe((resp) => {
        if (resp.isFinished === true) {
          self.zone.run(() => self.canOpenGraphicalTool = resp.result);
          //self.canOpenGraphicalTool = resp.result;
        } else {
          self.checkIfStpIsConverted();
        }
      });
    }, 2000);
  }
  sendSTPFile(file, id): void {
    this.canOpenGraphicalTool = false;
    this.mainPageService.sentSTPFileForChannels(file, id)
        .subscribe((response) => {
          this.channelData.stepFile = response.fileId;
          this.stpConvertTaskId = response.id;
          console.log(response);
          this.checkIfStpIsConverted();
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  openGraphicalTool(): void {
    this.onShowViewer.emit(true);
    //this.router.navigate(['/stp-configure']);
  }

  save(): void {
    Object.assign(this.channelData, this.editedChannel);
    // this.mainPageService.mysubject.next(this.channelData._id);
    this.mainPageService.updateChannelInDb(JSON.stringify(this.channelData)).subscribe(() => { });
  }

  deleteStepFile() {
    this.isStpVisible = false;
    this.mainPageService.deleteFile(this.channelData.stepFile).subscribe(() => {
    },
      () => {
      }
    );
    this.channelData.stepFile = null;
  }

  setFilesData(channel) {
    if (channel.picture !== undefined && channel.picture !== null && channel.picture !== '') {
      this.isPngVisible = true;
      this.mainPageService.getPicture(channel.picture).subscribe((res) => {
          this.pictureData = res.src;
        },
        (error: any) => {
          console.log(error);
        }
      );
    } else {
      this.pictureData = '';
      this.isPngVisible = false;
    }

    if (channel.stepFile !== undefined && channel.stepFile !== null && channel.stepFile !== '') {
      this.isStpVisible = true;
    } else {
      this.isStpVisible = false;
    }
  }

  deleteChannel() {
    this.mainPageService.removeChannel(this.channelData._id).subscribe(() => { }, () => { });
    this.mainPageService.deleteChannelSubject.next(this.channelData._id);
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.editedChannel.name, Validators.required),
      articleNumber: new FormControl(this.editedChannel.articleNumber),
      description: new FormControl(this.editedChannel.description),
      system: new FormControl(this.editedChannel.system, Validators.required),
      corrosionProtection: new FormControl(this.editedChannel.corrosionProtection, Validators.required),
      crossSection: new FormControl(this.editedChannel.crossSection, Validators.required),
      material: new FormControl(this.editedChannel.material, Validators.required),
    });
  }

  public filterCrossSections() {
    this.availableCrossSectionsArray = this.allCrossSectionsArray.filter(x => x.system === this.editedChannel.system);
  }
}
